/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./header.css";
import CTA from "./CTA";
import ME from "../../assets/me.png";
import HeaderSocials from "./HeaderSocials";

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h4 className="text-light">Hello I'm</h4>
        <h1>
          SHAMSUL{" "}
          <a href="#" className="header__content-color">
            AREFIN
          </a>
        </h1>
        <h3 className="text-light">Software Engineer</h3>
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={ME} alt="me" />
        </div>

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
